var exports = {
  "k": "xdbfd91f1--764479--container",
};

module.exports = exports;
